import React, { useEffect, useState } from "react";
import { Container, Button, Skeleton, Grid } from "@mui/material";
import BlogCard from "../common/BlogCard/BlogCard";
import { AxiosResponse, AxiosError } from "axios";
import {
  serviceFetchBlogs,
  serviceFetchBlogsThumbnail,
} from "../../api/service/services";
import blog_image from "../../assets/default_thumbnail_gradient.png";

interface Blog {
  id: number;
  title: { rendered: string };
  link: string;
  featured_media: number;
}

interface BlogWithImage extends Blog {
  imageUrl: string;
}

const BlogGrid: React.FC = () => {
  const [blogData, setBlogData] = useState<Blog[]>([]);
  const [blogsWithImages, setBlogsWithImages] = useState<BlogWithImage[]>([]);
  const [visibleCount, setVisibleCount] = useState(0);
  const [itemsPerRow, setItemsPerRow] = useState(4);

  useEffect(() => {
    // Set items per row based on screen size
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 1536) setItemsPerRow(5);
      else if (width >= 1200) setItemsPerRow(4);
      else if (width >= 900) setItemsPerRow(3);
      else if (width >= 600) setItemsPerRow(2);
      else setItemsPerRow(1);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    serviceFetchBlogs()
      .then((response: AxiosResponse) => {
        setBlogData(response?.data);
        setVisibleCount(itemsPerRow); // Show first batch
      })
      .catch((error: AxiosError) => {
        console.log("Error:", error.message);
      });
  }, [itemsPerRow]);

  useEffect(() => {
    const fetchThumbnails = async () => {
      const updatedBlogs = await Promise.all(
        blogData.map(async (blog) => {
          if (blog.featured_media > 0) {
            try {
              const response = await serviceFetchBlogsThumbnail(
                blog.featured_media
              );
              return {
                ...blog,
                imageUrl: response?.data?.source_url ?? blog_image,
              };
            } catch {
              return { ...blog, imageUrl: blog_image };
            }
          } else {
            return { ...blog, imageUrl: blog_image };
          }
        })
      );
      setBlogsWithImages(updatedBlogs);
    };

    if (blogData.length > 0) fetchThumbnails();
  }, [blogData]);

  const handleViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + itemsPerRow, blogsWithImages.length));
  };

  return (
    <Container maxWidth="xl" style={{ padding: "16px" }}>
      {blogsWithImages.length === 0 ? (
        <Skeleton variant="rounded" width="100%" height={300} animation="wave" />
      ) : (
        <>
          <Grid container spacing={1} justifyContent={"space-evenly"} >
            {blogsWithImages.slice(0, visibleCount).map((blog) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={blog.id}  sx={{ pl: 1,paddingBottom:3 }} >
                <BlogCard
                  id={blog.id.toString()}
                  cardBG={blog.imageUrl}
                  title={blog.title.rendered}
                  blogName={blog.title.rendered}
                  blogUrl={blog.imageUrl}
                />
              </Grid>
            ))}
          </Grid>
          <Grid item xs ={12} style={{ display: "flex", justifyContent: "center",margin:"24px", marginTop:"60px" }}>
          {visibleCount < blogsWithImages.length && (
            <Button
              variant="contained"
              onClick={handleViewMore}
             className="view-more-or-less"
                sx={{
                  fontWeight: 400,
 verticalAlign:"middle",
    background: "linear-gradient(90deg, #FF1400 0%, #0F0E96 100%)",
        WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    textFillColor: "transparent",
                }}
            >
              More Blogs
            </Button>
          )}
          </Grid>
        </>
      )}
    </Container>
  );
};

export default BlogGrid;
